'use client';

import type { ReactNode } from 'react';
import { EditToolArgsModal } from '../../EditToolArgsModal';
import type { EditModalProps } from '../../tool-config-types';

export const renderDefaultEditModal = (props: EditModalProps): ReactNode => (
  <EditToolArgsModal
    isOpen={props.isOpen}
    onClose={props.onClose}
    onSubmit={props.onSubmit}
    toolName={props.toolName || 'unknown'}
    args={props.args || {}}
    hiddenFields={[]}
  />
);
